import React, { useEffect, useState } from "react";
import Sidebar from "../../comman_page/Sidebar";
import { HeaderDashboard } from "../../comman_page/HeaderDashboard";
import { Container, Row, Col, Spinner } from "react-bootstrap";
import { Footer } from "../../../../../public/containers/footer/Footer";
import { useLocation } from "react-router-dom";
import { SharedButton } from "../../../../../sharedComponents/Button";
import moment from "moment";

export const DiscountTrDetailReport = () => {
    const location = useLocation();
    const [loader, setLoader] = useState(false);



    const [trData, setTrData] = useState([]);
    const [fullAm, setFullAm] = useState();




    const getReport = async (data) => {
        setLoader(true);
        let array = [];
        let full_amount = 0;
        if (data && data.length > 0) {
            (data ?? []).forEach(e => {
                let fnl = 0;

                fnl = parseFloat(e.finalSubTotal);
                full_amount += parseFloat(fnl);
                array.push({
                    subtotal: parseFloat(fnl).toFixed(2),
                    datetime: moment.unix(e.create_dt).format('DD-MMM-YYYY'),
                    client: e.name + ' ' + e.lastname,
                    method: "Credit/Debit",
                    discount_code_name: e.discount_code_name,
                    item: e.item_name,
                    amount: "$ " + parseFloat(fnl).toFixed(2) || 0,
                })
            });
            setTrData(array);
            setFullAm(parseFloat(full_amount).toFixed(2));
            setLoader(false);
        } else {
            setTrData([]);
        }
        setLoader(false);
    }



    useEffect(() => {
        if (location && location.state) {
            console.log(location.state);
            getReport(location.state)
        }
    }, [location.state])


    return (
        <>
            {loader && <div className='MainLoader'> <Spinner animation="border" role="status" className='Loader'> </Spinner> </div>}
            <div className="MainDashboard">
                <div className="MainLayout">
                    <Row>
                        <Sidebar />
                        <Col>
                            <div className="RightSide">
                                <HeaderDashboard />
                                <section className="addClient innerContent">
                                    <div className="AddClientContent">
                                        <Container>
                                            <h4 className="mb-4">Discount Code Transaction Detail Report</h4>
                                            <Row>
                                                <Col className="text-right">
                                                    <SharedButton
                                                        title={"Back"}
                                                        className={"backBtn"}
                                                        type={"button"}
                                                        onClick={() => {
                                                            window.history.back();
                                                        }}
                                                    />
                                                </Col></Row>
                                            <Row className="mt-3">
                                                <Col>
                                                    <div className="row transactionReport w-100">
                                                        <table className="table table-striped table-bordered">
                                                            <thead>
                                                                <tr>
                                                                    <th>Date/Time</th>
                                                                    <th>Client Name</th>
                                                                    <th>Method</th>
                                                                    <th>DiscountCode</th>
                                                                    <th>Item</th>
                                                                    <th>Amount</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody style={{ fontSize: '14px' }}>
                                                                {trData && trData.length > 0 && trData.map((row, index) => <tr key={index}>
                                                                    <td>{row.datetime}</td>
                                                                    <td>{row.client}</td>
                                                                    <td>{row.method}</td>
                                                                    <td>{row.discount_code_name}</td>
                                                                    <td>{row.item}</td>
                                                                    <td>{row.amount}</td>
                                                                    {/* <td>{row.detail}</td> */}
                                                                </tr>)}
                                                                {trData && trData.length > 0 &&
                                                                    <tr className='highlighted highlighted-my'>
                                                                        <td>Total</td>
                                                                        <td colspan="4"></td>
                                                                        <td colspan="2" style={{ width: 'auto', whiteSpace: 'nowrap' }}>$ {fullAm}</td>
                                                                    </tr>
                                                                }
                                                            </tbody>
                                                        </table>
                                                        {trData && trData.length <= 0 && (<p className="text-center mt-4">No Data Available</p>)}
                                                    </div>
                                                </Col>
                                            </Row>
                                        </Container>
                                    </div>
                                </section>
                                <Footer />
                            </div>
                        </Col>
                    </Row>
                </div>
            </div>
        </>
    );
};
